import type { ReactNode } from 'react';

type ErrorPanelProps = {
  title: string;
  message: string;
  /** Optional extra content rendered between the message and the actions. */
  children?: ReactNode;
  actions: ReactNode;
};

/**
 * Shared error-surface chrome used by `RouteErrorBoundary` (real errors)
 * and `NotFoundPage` (intentional 404s). Destructive-token surface +
 * heading; consumers supply their own action buttons and any optional
 * inline content between the message and the actions (e.g., a countdown).
 */
export function ErrorPanel({
  title,
  message,
  children,
  actions,
}: ErrorPanelProps): JSX.Element {
  return (
    <div
      role="alert"
      className="max-w-[640px] mx-auto my-16 p-6 rounded-xl border border-destructive/40 bg-destructive/10"
    >
      <h1 className="mt-0 text-h2 font-semibold text-destructive">{title}</h1>
      <p className="text-foreground">{message}</p>
      {children}
      <div className="flex gap-3 mt-4">{actions}</div>
    </div>
  );
}
